import { useMemo } from 'react';

import { selectUserEndpointToken } from 'modules/account/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchAccountStatusParams,
  selectAccountStatusDataWithFallback,
  selectAccountStatusInitialLoading,
  selectAccountStatusLoading,
  selectAccountStatusState,
} from '../actions/fetchAccountStatus';
import {
  selectAccountStatusError,
  selectAccountStatusLoaded,
  selectIsEnterprise,
  selectIsFreemium,
  selectIsInactive,
  selectIsPremium,
} from '../store/selectors';

export const useAccountStatus = () => {
  const userEndpointToken = useAppSelector(selectUserEndpointToken);

  const params = useMemo(
    (): IFetchAccountStatusParams => ({
      userEndpointToken: userEndpointToken!,
    }),
    [userEndpointToken],
  );

  const accountStatus = useAppSelector(state =>
    selectAccountStatusDataWithFallback(state, params),
  );
  const error = useAppSelector(state =>
    selectAccountStatusError(state, params),
  );
  const initalLoading = useAppSelector(state =>
    selectAccountStatusInitialLoading(state, params),
  );
  const loaded = useAppSelector(state =>
    selectAccountStatusLoaded(state, params),
  );
  const loading = useAppSelector(state =>
    selectAccountStatusLoading(state, params),
  );
  const isEnterprise = useAppSelector(state =>
    selectIsEnterprise(state, params),
  );
  const isInactive = useAppSelector(state => selectIsInactive(state, params));
  const isFreemium = useAppSelector(state => selectIsFreemium(state, params));
  const isPremium = useAppSelector(state => selectIsPremium(state, params));
  const state = useAppSelector(storeState =>
    selectAccountStatusState(storeState, params),
  );

  return {
    accountStatus,
    error,
    initialLoading: initalLoading,
    isEnterprise,
    isFreemium,
    isInactive,
    isPremium,
    loaded,
    loading,
    state,
  };
};
